import { useEffect, useState } from "react";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ContactSection from "@/components/home/ContactSection";

export default function ContactPage() {
  const [settings, setSettings] = useState({});
  useEffect(() => { window.scrollTo(0, 0); api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  return (
    <div className="bg-[#090A0F] min-h-screen">
      <Header />
      <main className="pt-20"><ContactSection /></main>
      <Footer settings={settings} />
    </div>
  );
}
